namespace Areas.Dialogs.SubmitTime {
    "use strict";

    export class SubmitTimeDialog extends Areas.BaseDialog {
        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("SubmitTimeConfirmation", closeHandler)
        }

        protected ok = (e: any) => {
            this.close(DialogResult.Ok, null); 
        }
    }

}